const dateMacros = [
  {
    key: 'Custom',
    text: 'Custom',
    value: 'custom',
  },
  {
    key: 'Today',
    text: 'Today',
    value: 'Today',
  },
  {
    key: 'Yesterday',
    text: 'Yesterday',
    value: 'Yesterday',
  },
  {
    key: 'ThisWeek',
    text: 'This Week',
    value: 'This Week',
  },
  {
    key: 'LastWeek',
    text: 'Last Week',
    value: 'Last Week',
  },
  {
    key: 'ThisWeektodate',
    text: 'This Week To Date',
    value: 'This Week-to-date',
  },
  {
    key: 'LastWeektodate',
    text: 'Last Week To Date',
    value: 'Last Week-to-date',
  },
  {
    key: 'NextWeek',
    text: 'Next Week',
    value: 'Next Week',
  },
  {
    key: 'Next4Weeks',
    text: 'Next 4 Weeks',
    value: 'Next 4 Weeks',
  },
  {
    key: 'ThisMonth',
    text: 'This Month',
    value: 'This Month',
  },
  {
    key: 'LastMonth',
    text: 'Last Month',
    value: 'Last Month',
  },
  {
    key: 'ThisMonthtodate',
    text: 'This Month To Date',
    value: 'This Month-to-date',
  },
  {
    key: 'LastMonthtodate',
    text: 'Last Month To Date',
    value: 'Last Month-to-date',
  },
  {
    key: 'NextMonth',
    text: 'Next Month',
    value: 'Next Month',
  },
  {
    key: 'ThisFiscalQuarter',
    text: 'This Fiscal Quarter',
    value: 'This Fiscal Quarter',
  },
  {
    key: 'LastFiscalQuarter',
    text: 'Last Fiscal Quarter',
    value: 'Last Fiscal Quarter',
  },
  {
    key: 'ThisFiscalQuartertodate',
    text: 'This Fiscal Quarter To Date',
    value: 'This Fiscal Quarter-to-date',
  },
  {
    key: 'LastFiscalQuartertodate',
    text: 'Last Fiscal Quarter To Date',
    value: 'Last Fiscal Quarter-to-date',
  },
  {
    key: 'NextFiscalQuarter',
    text: 'Next Fiscal Quarter',
    value: 'Next Fiscal Quarter',
  },
  {
    key: 'ThisFiscalYear',
    text: 'This Fiscal Year',
    value: 'This Fiscal Year',
  },
  {
    key: 'LastFiscalYear',
    text: 'Last Fiscal Year',
    value: 'Last Fiscal Year',
  },
  {
    key: 'ThisFiscalYeartodate',
    text: 'This Fiscal Year To Date',
    value: 'This Fiscal Year-to-date',
  },
  {
    key: 'LastFiscalYeartodate',
    text: 'Last Fiscal Year To Date',
    value: 'Last Fiscal Year-to-date',
  },
  {
    key: 'NextFiscalYear',
    text: 'Next Fiscal Year',
    value: 'Next Fiscal Year',
  },
  {
    key: 'ThisCalendarQuarter',
    text: 'This Calendar Quarter',
    value: 'This Calendar Quarter',
  },
  {
    key: 'LastCalendarQuarter',
    text: 'Last Calendar Quarter',
    value: 'Last Calendar Quarter',
  },
  {
    key: 'ThisCalendarQuartertodate',
    text: 'This Calendar Quarter To Date',
    value: 'This Calendar Quarter-to-date',
  },
  {
    key: 'LastCalendarQuartertodate',
    text: 'Last Calendar Quarter To Date',
    value: 'Last Calendar Quarter-to-date',
  },
  {
    key: 'NextCalendarQuarter',
    text: 'Next Calendar Quarter',
    value: 'Next Calendar Quarter',
  },
  {
    key: 'ThisCalendarYear',
    text: 'This Calendar Year',
    value: 'This Calendar Year',
  },
  {
    key: 'LastCalendarYear',
    text: 'Last Calendar Year',
    value: 'Last Calendar Year',
  },
  {
    key: 'ThisCalendarYeartodate',
    text: 'This Calendar Year To Date',
    value: 'This Calendar Year-to-date',
  },
  {
    key: 'LastCalendarYeartodate',
    text: 'Last Calendar Year To Date',
    value: 'Last Calendar Year-to-date',
  },
  {
    key: 'NextCalendarYear',
    text: 'Next Calendar Year',
    value: 'Next Calendar Year',
  },
];

export default dateMacros;
